export enum NotificationType {
  message = 'message',
  rewards = 'rewards',
}
